import { NotificationType } from "./NotificationContext";
interface NotificationOptions {
  title?: string;
  duration?: number;
  icon?: string;
  actions?: Array<{
    label: string;
    onClick: () => void;
  }>;
}

export const DEFAULT_SUCCESS_NOTIFICATION_DURATION = 5000;

// Global notification instance
let notifyInstance: any = null;

// Set notification instance
export const setNotifyInstance = (instance: any) => {
  notifyInstance = instance;
};

// Create notification API
const createNotify = () => {
  const notify = (message: string, type: NotificationType, options?: NotificationOptions) => {
    if (!notifyInstance) {
      console.warn("Notification provider not initialized");
      return "";
    }

    return notifyInstance.addNotification({
      type,
      message,
      title: options?.title,
      duration: options?.duration,
      icon: options?.icon,
      actions: options?.actions,
    });
  };

  return {
    success: (message: string, options?: NotificationOptions) =>
      notify(message, "success", {
        ...options,
        duration:
          options?.duration ??
          (options?.actions?.length ? undefined : DEFAULT_SUCCESS_NOTIFICATION_DURATION),
      }),

    warning: (message: string, options?: NotificationOptions) =>
      notify(message, "warning", options),

    error: (message: string, options?: NotificationOptions) => notify(message, "error", options),

    info: (message: string, options?: NotificationOptions) => notify(message, "info", options),

    close: (id: string) => {
      if (!notifyInstance) {
        console.warn("Notification provider not initialized");
        return;
      }
      notifyInstance.removeNotification(id);
    },
  };
};

// Export notification API
export const notify = createNotify();
